import sliderStyle from "../slider.module.scss";

import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show_hover.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as WarningIcon } from "assets/images/icons/icn_btn_authenticate_red.svg";

import React, { useEffect, useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";

import { SolidButton } from "components/buttons/SolidButton";
import { SolidButton as SolidRectangleButton } from "components/buttons/SolidRectangleButton";
import { authStateOption } from "../../../const";
import { getDefaultTextFieldProp } from "../../../../theme";

const Overview = ({
  device,
  authenticateDevice,
  authenticatingDeviceId,
  showAuthenticationError,
  openAdoption,
}) => {
  const [openForm, setOpenForm] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [waiting, setWaiting] = useState(false);

  useEffect(() => {
    setOpenForm(false);
    setIsPassword(false);
    setUsername("");
    setPassword("");
    setWaiting(false);
  }, [device?.deviceId]);

  useEffect(() => {
    if (!waiting) {
      return;
    }

    if (authenticatingDeviceId !== device?.deviceId) {
      setWaiting(false);
    }
  }, [authenticatingDeviceId, device?.deviceId, waiting]);

  if (!device) {
    return null;
  }

  const isAuthenticated = device.authStatus === authStateOption.passed;
  const canSubmit = username.length > 0 && password.length > 0 && !waiting;

  const authenticate = () => {
    if (!canSubmit) {
      return;
    }

    setWaiting(true);
    authenticateDevice(device, username, password);
  };

  return (
    <>
      <Box className={sliderStyle["field-container"]}>
        <Box className={sliderStyle.field}>Auth</Box>
        <Box className={sliderStyle.value}>
          {isAuthenticated ? (
            <div className={sliderStyle.success}>Configurable</div>
          ) : (
            <Box className={sliderStyle.auth}>
              <Box
                className={`${sliderStyle.btn} ${sliderStyle.warning}`}
                onClick={() => setOpenForm(!openForm)}
              >
                <WarningIcon />
                {showAuthenticationError ? "Authentication Failed" : "Authentication Required"}
              </Box>
            </Box>
          )}
        </Box>

        {openForm && !isAuthenticated && (
          <>
            <Box className={sliderStyle.field} style={{ justifyContent: "end" }}>
              <li>Username</li>
            </Box>
            <Box className={sliderStyle.value}>
              <TextField
                fullWidth
                type="text"
                value={username}
                autoComplete="new-password"
                onChange={(event) => setUsername(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
              />
            </Box>

            <Box className={sliderStyle.field} style={{ justifyContent: "end" }}>
              <li>Password</li>
            </Box>
            <Box className={sliderStyle.value}>
              <TextField
                fullWidth
                type={isPassword ? "text" : "password"}
                value={password}
                autoComplete="new-password"
                onChange={(event) => setPassword(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
                InputProps={{
                  endAdornment: isPassword ? (
                    <InputAdornment position="end">
                      <ShowIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="end">
                      <HideIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {showAuthenticationError && (
              <>
                <Box className={sliderStyle.field}></Box>
                <Box className={sliderStyle.value}>
                  <div className={sliderStyle.error}>
                    Invalid username or password
                  </div>
                </Box>
              </>
            )}

            <Box className={sliderStyle.field}></Box>
            <Box className={sliderStyle.value}>
              <SolidRectangleButton
                className={`${sliderStyle.submit_btn} ${canSubmit ? sliderStyle.enabled_btn : sliderStyle.disabled_btn}`}
                onClick={authenticate}
              >
                {waiting ? "Authenticating" : "Submit"}
              </SolidRectangleButton>
            </Box>
          </>
        )}

        <Box className={sliderStyle.field}>IP Address</Box>
        <Box className={sliderStyle.value}>{device.ipAddress || "-"}</Box>

        <Box className={sliderStyle.field}>MAC Address</Box>
        <Box className={sliderStyle.value}>{device.deviceId || "-"}</Box>

        <Box className={sliderStyle.field}>Model Name</Box>
        <Box className={sliderStyle.value}>{device.modelName || "-"}</Box>

        <Box className={sliderStyle.field}>Firmware Version</Box>
        <Box className={sliderStyle.value}>{device.fwVersion || device.version || "-"}</Box>

        <Box className={sliderStyle.field}>Hardware Version</Box>
        <Box className={sliderStyle.value}>{device.hardwareRevision || device.hardwareVersion || "-"}</Box>
      </Box>

      {!device.provisioning && (
        <Box className={sliderStyle["button-container"]}>
          <SolidButton
            className={`${sliderStyle["apply-btn"]} ${isAuthenticated ? sliderStyle.enabled_btn : sliderStyle.disabled_btn}`}
            onClick={() => {
              if (isAuthenticated) {
                openAdoption([device]);
              }
            }}
          >
            <span className={sliderStyle.text}>Adopt</span>
          </SolidButton>
        </Box>
      )}
    </>
  );
};

export default Overview;
